const UPDATE_COUPONS = "UPDATE_COUPONS";
const DELETE_COUPON = "DELETE_COUPON";
const UPDATE_RANK_COUPONS = "UPDATE_RANK_COUPONS";
const DELETE_RANK_COUPON = "DELETE_RANK_COUPON";

const createState = () => {
  return {
    coupons: [
      {
        couponNum: 0,
        couponsToDistribute: "1"
      }
    ],
    rankSettingCoupons: [
      {
        couponNum: 0,
        couponsToDistribute: "1"
      }
    ]
  }
};

export default {
  namespaced: true,
  state: createState(),
  getters: {},
  mutations: {
    [UPDATE_COUPONS](state, payload) {
      state.coupons = [...state.coupons, payload];
    },
    [DELETE_COUPON](state, payload) {
      state.coupons = payload;
    },
    [UPDATE_RANK_COUPONS](state, payload) {
      state.rankSettingCoupons = [...state.rankSettingCoupons, payload];
    },
    [DELETE_RANK_COUPON](state, payload) {
      state.rankSettingCoupons = payload;
    }
  },
  actions: {
    updateCoupons({ commit }, payload) {
      commit(UPDATE_COUPONS, payload)
    },
    deleteCoupon({ commit }, payload) {
      commit(DELETE_COUPON, payload)
    },
    updateRankCoupons({ commit }, payload) {
      commit(UPDATE_RANK_COUPONS, payload)
    },
    deleteRankCoupon({ commit }, payload) {
      commit(DELETE_RANK_COUPON, payload)
    },
  }
}